"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getOptionsWithPreSelection;
var _axios = _interopRequireDefault(require("axios"));
function buildGetOptionsParameters(productId, configurationId, externalProductId, partnerProductId, choiceTagsForPreSelection, choiceTagsForValuePersisit) {
  if (configurationId) {
    return {
      productId: productId,
      configurationIdForSelections: configurationId
    };
  }
  if (externalProductId) {
    return {
      productId: productId,
      externalProductId: externalProductId,
      selectedChoicesEquivalenceKeys: choiceTagsForPreSelection,
      selectedValuesByTagsKeys: choiceTagsForValuePersisit
    };
  }
  if (partnerProductId) {
    return {
      productId: productId,
      partnerProductId: partnerProductId,
      selectedChoicesEquivalenceKeys: choiceTagsForPreSelection,
      selectedValuesByTagsKeys: choiceTagsForValuePersisit
    };
  }
  return {
    productId: productId,
    selectedChoicesEquivalenceKeys: choiceTagsForPreSelection,
    selectedValuesByTagsKeys: choiceTagsForValuePersisit
  };
}
function getOptionsWithPreSelection(preSelectOptionsApi, productId, configurationId, externalProductId, partnerProductId, choiceTagsForPreSelection, choiceTagsForValuePersisit) {
  return _axios["default"].post(preSelectOptionsApi, buildGetOptionsParameters(productId, configurationId, externalProductId, partnerProductId, choiceTagsForPreSelection, choiceTagsForValuePersisit)).then(function (response) {
    return response;
  })["catch"](function (error) {
    console.error(error); // eslint-disable-line no-console
  });
}
//# sourceMappingURL=optionsApiWithPreSelection.js.map